import styled, { css } from 'styled-components'

import { SectionProps } from './Section.props'

import { isColor } from 'theme/styled'

const SECTION_STYLE = css<SectionProps>`
  padding: 4rem 0;
  width: 100%;
  background-color: ${({ theme, backgroundColor = 'white' }) =>
    isColor(backgroundColor) ? theme.colors[backgroundColor] : 'transparent'};
  background-image: ${({ backgroundImage }) =>
    backgroundImage ? `url(${backgroundImage})` : 'initial'};
  ${({ backgroundImage }) =>
    backgroundImage &&
    `
      background-repeat: no-repeat;
      background-size: cover;
      background-position: bottom center;
  }
  `}
`

export const SectionContent = styled.div`
  ${SECTION_STYLE}
`
